import Contract from './index'

// import ContractPosition from './contractPosition'
// import CurrentDelegation from './currentDelegation'
// import ClosingCommission from './closingCommission'
// import TransactionRecord from './transactionRecord'
// import TransactionSummary from './transactionSummary'
// import ContractHistory from './contractHistory'
import HeadInch from './headInch'
import Active from './active'
import Plan from './plan'
import ProfitLoss from './profit'
import ActiveHistory from './activeHistory'
import PlanHistory from './planHistory'
import ProfitLossHistory from './profitLossHistory'
import MoveProfitLoss from './moveProfit'
export default {
  path: '/home/tiger',
  component: Contract,
  meta: { titie: '合约持仓管理' },
  children: [
    {
      path: '/home/tiger/head-inch',
      meta: { titie: '仓位净头寸' },
      component: HeadInch,
    },
    {
      path: '/home/tiger/active',
      meta: { titie: '限价委托' },
      component: Active,
    }, //限价委托
    {
      path: '/home/tiger/plan',
      meta: { titie: '计划委托' },
      component: Plan,
    }, //计划委托
    {
      path: '/home/tiger/profitLoss',
      meta: { titie: '止盈止损' },
      component: ProfitLoss,
    }, //止盈止损
    {
      path: '/home/tiger/moveProfitLoss',
      meta: { titie: '止盈止损' },
      component: MoveProfitLoss,
    }, // 移动止盈止损
    {
      path: '/home/tiger/active-history',
      meta: { titie: '活跃委托历史' },
      component: ActiveHistory,
    }, //活跃委托历史
    {
      path: '/home/tiger/plan-history',
      meta: { titie: '计划委托历史' },
      component: PlanHistory,
    }, //计划委托历史
    {
      path: '/home/tiger/profitLoss-history',
      meta: { titie: '止盈止损历史' },
      component: ProfitLossHistory,
    }, //计划委托历史
    // {
    //   path: '/home/closingCommission',
    //   meta: { titie: '平仓记录' },
    //   component: ClosingCommission,
    // },
    // {
    //   path: '/home/contractHistory',
    //   meta: { titie: '历史仓位记录' },
    //   component: ContractHistory,
    // }, //平仓委托
    // //平仓委托
    // {
    //   path: '/home/transactionRecord',
    //   meta: { titie: '开仓记录' },
    //   component: TransactionRecord,
    // }, //成交记录
    // {
    //   path: '/home/transactionSummary',
    //   meta: { titie: '成交汇总查询' },
    //   component: TransactionSummary,
    // }, //成交汇总
  ],
}
